import { getMessages } from '../../../../../../store/constants';

export const TIMEZONE_TITLE =  getMessages().getText('timezone.select.title');
export const TIMEZONE_TEXT = getMessages().getText('timezone.select.text');
export const TIMEZONE_MORE_INSTRUCTIONS = getMessages().getText('timezone.select.more_instructions');
